import { render, staticRenderFns } from "./MassSelectArchiveConfirmModal.vue?vue&type=template&id=682f26f6"
import script from "./MassSelectArchiveConfirmModal.vue?vue&type=script&lang=ts"
export * from "./MassSelectArchiveConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports